<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <!-- <span>Linked IPCR</span> -->
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-card>
            <v-row>
              <!-- <v-col cols="8" class="flex-items mt-2">
                <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                  <v-tab
                    v-for="tab in tabList"
                    :key="tab.id"
                    @click="changeTab(tab)"
                    >{{ tab.name }}</v-tab
                  >
                </v-tabs>
              </v-col> -->
              <v-spacer></v-spacer>

              <v-col cols="12">
                <div
                  class="pa-2 rounded-lg elevation-2"
                  style="border: 1px solid #ddd"
                >
                  <div class="text-subtitle-1 pa-2">OPCR Target</div>
                  <v-divider></v-divider>
                  <div class="pa-2 d-flex">
                    <div class="text-body font-weight-bold">Type:</div>
                    <div class="text-body ml-2">
                      {{ tab == 1 ? "Core Function" : "Strategic Priority" }}
                    </div>
                  </div>
                  <div class="pa-2 d-flex align-center">
                    <div class="text-body font-weight-bold">MFO:</div>
                    <div class="text-body ml-2">{{ data && data.mfo }}</div>
                  </div>
                  <div class="pa-2 d-flex align-center">
                    <div class="text-body font-weight-bold">Target:</div>
                    <div class="text-body ml-2">
                      {{
                        tab == 1
                          ? data && data.efficiency
                          : data && data.tagged_target
                      }}
                    </div>
                  </div>

                  <div class="pa-2 d-flex align-center">
                    <div class="text-body font-weight-bold">
                      Success Indicator:
                    </div>
                    <div class="text-body ml-2">
                      {{ tab == 1 ? data && data.success_indicator : "" }}
                    </div>
                  </div>
                  <div class="pa-2 d-flex align-center">
                    <div class="text-body font-weight-bold">
                      Actual Accomplishment:
                    </div>
                    <div class="text-body ml-2">
                      {{ tab == 1 ? data && data.actual_accomplishment : "" }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" class="pt-2 px-4">
                <div class="text-subtitle-1 pa-2">Linked IPCR</div>
                <v-data-table
                  :headers="headers"
                  :items="dataItem"
                  :items-per-page="10"
                >
                  <!-- <template v-slot:[`item.efficiency`]="{ item }">
                    <div class="d-flex align-center justify-center">
                      <div class="text-caption" v-if="item.eff_is_rated == 1">
                        {{
                          item.ipcr_rate.e_total
                            ? "(" +
                              item.ipcr_rate.e_total +
                              ") " +
                              item.ipcr_rate.e_avg
                            : null
                        }}
                      </div>
                      <div
                        class="text-caption font-weight-bold"
                        v-if="item.eff_is_rated == 0"
                      >
                        NR
                      </div>
                    </div>
                  </template> -->
                </v-data-table>
              </v-col>
            </v-row>
            <!-- <v-row v-if="isSubmitted && assessed_by_status == 2">
              <v-col cols="12">
                <v-divider></v-divider>
                <div class="pa-3">
                  <div class="text-h6">
                    Comments and Recommendations for Development Purposes:
                  </div>
                  <div class="text-justify text-subtitle-1">
                    {{ targetRating.comments }}
                  </div>
                </div>
              </v-col>
            </v-row> -->
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <!-- <v-fab-transition v-if="isSubmitted">
            <v-menu top>
              <template v-slot:activator="{ on }">
                <v-btn color="#519043" left outlined v-on="on">
                  Remarks
                </v-btn>
              </template>

              <v-card class="mx-auto" width="600" max-width="600" elevation-4>
                <v-card-title class="dialog-header  white--text">
                  <span class="text-h6">Remarks</span>
                </v-card-title>
                <v-card-text
                  class="py-0"
                  style="background-color:white;  height : 300px; overflow-y:auto"
                >
                  <v-timeline dense v-if="remarksData.length > 0">
                    <v-timeline-item
                      v-for="item in remarksData"
                      :key="item.id"
                      small
                      color="#519043"
                      icon="mdi-comment-processing-outline"
                      fill-dot
                    >
                      <v-alert :value="true">
                        <div class="text-h6">
                          {{
                            $store.getters.getUserData.id ==
                            item.remarks_maker_userID
                              ? "You"
                              : item.remarks_by
                          }}
                        </div>
                        <div class="text-body-1">
                          {{ item.message }}
                        </div>
                        <div class="text-caption">
                          <i>{{ formatDate(item.created_at) }}</i>
                        </div>
                      </v-alert>
                    </v-timeline-item>
                  </v-timeline>
                  <v-timeline dense v-if="remarksData.length == 0">
                    <v-timeline-item
                      small
                      color="#519043"
                      icon="mdi-comment-processing-outline"
                      fill-dot
                    >
                      <v-alert :value="true">
                        <div class="text-body-1">
                          No remarks found.
                        </div>
                      </v-alert>
                    </v-timeline-item>
                  </v-timeline>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-fab-transition> -->
          <v-spacer></v-spacer>

          <!-- <v-btn color="red" outlined @click="closeD()">
            <v-icon>mdi-close-circle-outline</v-icon>
            Close
          </v-btn> -->

          <v-btn
            color="#519043"
            class="white--text"
            @click="
              !hasAddedAccomplishment
                ? saveAccomplishment()
                : updateAccomplishment()
            "
          >
            {{
              !hasAddedAccomplishment
                ? "Save as Target Accomplishment"
                : "Update Target Accomplishment"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- confirm dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 my-2">
            <div v-html="savingAction"></div>
          </div>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelConfirm()"> CANCEL </v-btn>
          <v-btn
            :disabled="isButtonLoading"
            :loading="isButtonLoading"
            color="green"
            class="white--text"
            @click="confirmSave()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddAccomplishmentDialog
      :data="opcrData"
      :action="action"
      :opcrID="id"
      :tab="tab"
      :myTaggingType="myTaggingType"
    />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="fadeAwayMessage.timeout"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    AddAccomplishmentDialog: () =>
      import("../OPCR/AddAccomplishmentDialog.vue"),
  },
  props: {
    data: null,
    myTaggingType: null,
    tab: null,
  },
  data() {
    return {
      remarksData: [],
      confirmBtnLoading: false,
      confirmSubmitDialog: false,
      confirmDialog: false,
      savingAction: null,
      itemToDelete: null,
      assesed_by_status: null,
      options: {},
      action: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
        timeout: 1500,
      },
      dialog: false,
      //   activeTab: { id: 1, name: "Core Functions" },
      //   tab: 1,
      //   tabList: [
      //     { id: 1, name: "Core Functions" },
      //     { id: 2, name: "Strategic Priority" },
      //   ],
      opcrData: null,
      opcrSupData: null,
      isSubmitted: null,
      targetRating: null,
      isSubmitLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      id: null,
      ipcrSupport: null,
      dataItem: [],
      expanded: [],
      // accomplishments: [],
      isButtonLoading: false,
      headers: [
        {
          text: "Name",
          value: "name",
          width: 200,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "MFO",
          value: "mfo",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "ipcr_rate.success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },

        {
          text: "Actual Accomplishment",
          value: "ipcr_rate.actual_accomplishment",
          align: "start",
          valign: "center",
          sortable: false,
        },
        // {
        //   text: "Efficiency",
        //   value: "efficiency",
        //   align: "center",
        //   valign: "center",
        //   sortable: false,
        // },
        // {
        //   text: "Q",
        //   value: "quality",
        //   align: "center",
        //   valign: "center",
        //   sortable: false,
        // },
        // {
        //   text: "T",
        //   value: "timeliness",
        //   align: "center",
        //   valign: "center",
        //   sortable: false,
        // },

        // {
        //   text: "Action",
        //   value: "action",
        //   width: 150,
        //   align: "end",
        // },
      ],
      cascade_headers: [
        {
          text: "Office",
          value: "officeName",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Office Head",
          value: "name",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Tagged Target/s",
          value: "efficiency",
          align: "center",
          width: 300,
          valign: "center",
          sortable: false,
        },
        // {
        //   text: "Alloted Budget",
        //   value: "alloted_budget",
        //   align: "center",
        //   valign: "center",
        //   sortable: false,
        // },
        {
          text: "Actual Accomplishment",
          value: "actual_accomplishment",
          align: "start",
          valign: "center",
          sortable: false,
        },

        {
          text: "Action",
          value: "action",
          width: 150,
          align: "end",
        },
      ],
      sp_headers: [
        {
          text: "Code",
          value: "code",
          width: 100,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "MFO",
          value: "mfo",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Tagged Target/s",
          value: "tagged_target",
          align: "center",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Alloted Budget",
          value: "alloted_budget",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "Actual Accomplishment",
          value: "actual_accomplishment",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          width: 150,
          align: "end",
        },
      ],

      accomplishments_headers: [
        // {
        //   text: "Description",
        //   value: "description",
        //   align: "start",
        //   valign: "start",
        //   sortable: false,
        // },
        {
          text: "Accomplishment Achieved",
          value: "accomplishment",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Date Added",
          value: "date_added",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          width: 150,
          align: "end",
        },
      ],
      support_headers: [
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          sortable: false,
        },
        {
          text: "Actual Accomplishment",
          value: "actual_accom",
          align: "center",

          valign: "center",
          sortable: false,
        },

        {
          text: "To be Rated",
          value: "eqt",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
        },
      ],
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("CASCADED", data);
        // this.isSubmitted = data.isSubmitted;
        // this.assessed_by = this.toTitleCase(data.assessed_by_name);
        // this.assessed_by_status = data.assesed_by_status;
        this.id = data.id;
        // this.activeTab = { id: 1, name: "Core Functions" };
        // this.tab = 1;
        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },

  computed: {
    getTotalEfficiency() {
      let total = 0;
      if (this.data && this.data.total_accomplishment) {
        total = this.data.total_accomplishment;
      } else {
        for (let i = 0; i < this.dataItem.length; i++) {
          total += this.dataItem[i].ipcr_rate.e_total
            ? this.dataItem[i].ipcr_rate.e_total
            : 0;
        }
      }

      return total;
    },
    hasAddedAccomplishment() {
      let has = false;
      if (this.data && this.data.accomplishments.length > 0) {
        has = true;
      }
      return has;
    },
  },
  mounted() {
    this.eventHub.$on("closeAddAccomplishmentDialog", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeAddAccomplishmentDialog");
  },

  methods: {
    initialize() {
      this.confirmDialog = false;
      this.loading = true;

      this.axiosCall(
        "/opcr-target/loadLinkedIPCRTarget/" + this.data.id + "/" + this.tab,
        "GET"
      ).then((res) => {
        let data = res.data;
        console.log("tagged hhtht", data);
        for (let i = 0; i < data.length; i++) {
          data[i].name = this.toTitleCase(data[i].name);
        }
        this.dataItem = data;
      });
    },

    // getAccomplishment() {
    //   this.axiosCall(
    //     "/opcr-target/getAccomplishments/" + this.data.id + "/" + this.tab,
    //     "GET"
    //   ).then((res) => {
    //     (this.accomplishments = res.data),
    //       console.log("accomplishments", res.data);
    //   });
    // },

    shouldSubmit() {
      if (this.isSubmitted == 0) {
        return true;
      } else {
        if (this.assessed_by_status == 1 || this.assessed_by_status == 2) {
          return false;
        } else {
          return true;
        }
      }
    },

    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/OPCR_TARGET", "GET").then((res) => {
          if (res.data) {
            console.log("remarks", res.data);
            this.remarksData = res.data;
          }
        });
      }
    },
    closeD() {
      this.eventHub.$emit("closeViewCascadedAccomplishmentDialog", false);
      this.confirmSubmitDialog = false;
      this.confirmBtnLoading = false;
      this.isSubmitLoading = false;
      this.dialog = false;
    },
    // add_accomplishment(item) {
    //   console.log("RATEssssss", item);
    //   this.opcrData = {
    //     targetType: this.tab,
    //     targetID:
    //       this.tab == 1
    //         ? item.id
    //         : this.myTaggingType.type == "vp"
    //         ? item.id
    //         : item.OpcrPapTargetDistributedTaggingID,
    //     opcrID: this.id,
    //     taggedTarget: item.target,
    //     QL_is_rated: this.tab == 1 ? item.QL_is_rated : true,
    //     timeliness_is_rated: this.tab == 1 ? item.timeliness_is_rated : true,
    //     Q_rating: item.Q_rating,
    //     T_rating: item.T_rating,
    //     success_indicator: item.success_indicator,
    //     efficiency:
    //       this.tab == 1
    //         ? item.efficiency
    //         : this.myTaggingType.type == "vp"
    //         ? item.target
    //         : item.tagged_target,
    //   };
    //   this.expanded = [];
    //   // console.log("RATE", this.opcrData);
    //   this.action = "Add";
    // },

    // update_accomplishment(item, parent) {
    //   console.log("UPDATE DATA", item, parent);
    //   // this.opcrData = item;
    //   this.opcrData = {
    //     accomplishment: item.accomplishment,
    //     accomplishment_id: item.id,
    //     targetType: this.tab,
    //     targetID: parent.id,
    //     opcrID: this.myTaggingType.type == "vp" ? this.data.id : parent.opcrID,
    //     taggedTarget: parent.target,
    //     QL_is_rated: this.tab == 1 ? parent.QL_is_rated : true,
    //     timeliness_is_rated: this.tab == 1 ? parent.timeliness_is_rated : true,
    //     Q_rating: parent.Q_rating,
    //     T_rating: parent.T_rating,
    //     success_indicator: parent.success_indicator,
    //     efficiency: parent.efficiency,
    //     attachment: item.attachment,
    //     remarks: parent.remarks,
    //   };
    //   this.expanded = [];
    //   this.action = "Update";
    // },

    // view_accomplishment(item) {
    //   this.opcrData = {
    //     targetType: this.tab,
    //     targetID:
    //       this.tab == 1
    //         ? item.id
    //         : this.myTaggingType.type == "vp"
    //         ? item.id
    //         : item.OpcrPapTargetDistributedTaggingID,
    //     opcrID: this.id,
    //     taggedTarget: item.target,
    //     QL_is_rated: this.tab == 1 ? item.QL_is_rated : true,
    //     timeliness_is_rated: this.tab == 1 ? item.timeliness_is_rated : true,
    //     Q_rating: item.Q_rating,
    //     T_rating: item.T_rating,
    //     success_indicator: item.success_indicator,
    //     efficiency:
    //       this.tab == 1
    //         ? item.efficiency
    //         : this.myTaggingType.type == "vp"
    //         ? item.target
    //         : item.tagged_target,
    //   };
    //   this.expanded = [];
    //   // console.log("RATE", this.opcrData);
    //   this.action = "Add";
    // },

    submitTarget() {
      this.confirmSubmitDialog = true;
    },

    confirmSave() {
      console.log("THIS IS DATA", this.data);
      this.opcrData = {
        accomplishment: this.getTotalEfficiency,
        accomplishment_id:
          this.data.accomplishments.length > 0
            ? this.data.accomplishments[0].id
            : null,
        targetType: this.tab,
        // targetID: this.data.id,
        targetID:
          this.tab == 1
            ? this.data.id
            : this.myTaggingType.type != "vp"
            ? this.data.OpcrPapTargetDistributedTaggingID
            : this.data.id,
        opcrID: this.data.opcrID,
        // taggedTarget: this.tab == 1 ? this.data.efficiency : this.data.target,
        taggedTarget:
          this.tab == 1 ? this.data.efficiency : this.data.tagged_target,
        QL_is_rated: this.tab == 1 ? this.data.QL_is_rated : true,
        timeliness_is_rated:
          this.tab == 1 ? this.data.timeliness_is_rated : true,
        Q_rating: this.data.Q_rating,
        T_rating: this.data.T_rating,
        success_indicator:
          this.data.mfo + " " + this.data.QT + " " + this.data.timeliness,
        efficiency: this.data.efficiency,
        attachment:
          this.data.accomplishments.length > 0
            ? this.data.accomplishments[0].attachment
            : [],
        remarks: this.data.remarks,
      };
      this.action = this.data.accomplishments.length > 0 ? "Update" : "Add";

      // this.closeD();
    },

    cancelConfirm() {
      this.confirmDialog = false;
    },

    saveAccomplishment() {
      if (this.dataItem.length > 0) {
        this.savingAction =
          "<div class='text-justify'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Are you sure you want to <b>SAVE</b> this as your OPCR Target Accomplishment?</div>";
        this.confirmDialog = true;
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "No IPCR linked found!";
        this.fadeAwayMessage.timeout = 3000;
      }
    },

    updateAccomplishment() {
      this.savingAction =
        "<div class='text-justify'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Are you sure you want to <b>UPDATE</b> your OPCR Target Accomplishment?</div>";
      this.confirmDialog = true;
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
    },

    confirmDelete() {
      this.isButtonLoading = true;
      this.axiosCall(
        "/opcr-target/deleteAccomplishment/" + this.itemToDelete.id,
        "DELETE"
      ).then((res) => {
        if (res.data.status == 200) {
          this.confirmDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
          this.itemToDelete = null;
          this.confirmDialog = false;

          this.initialize();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
        }
      });
    },
  },
};
</script>
<style scoped></style>
